import React from 'react';
import { Helmet } from 'react-helmet';
import SignupForm from './components/SignupForm';
import LoginHeader from '../login/components/LoginHeader';
import SecurityBadges from '../login/components/SecurityBadges';

export default function SignupPage() {
  return (
    <>
      <Helmet>
        <title>Sign Up - LocalProCRM</title>
        <meta name="description" content="Create your LocalProCRM account to get started with powerful home services management" />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex flex-col">
        {/* Header */}
        <LoginHeader />

        {/* Main Content */}
        <div className="flex-1 flex items-center justify-center px-4 py-12">
          <div className="w-full max-w-md">
            {/* Signup Form Card */}
            <div className="bg-white rounded-2xl shadow-xl p-8">
              <div className="text-center mb-8">
                <h1 className="text-3xl font-bold text-gray-900 mb-2">
                  Create Account
                </h1>
                <p className="text-gray-600">
                  Get started with your free trial
                </p>
              </div>

              <SignupForm />
            </div>

            {/* Security Badges */}
            <SecurityBadges />
          </div>
        </div>
      </div>
    </>
  );
}